// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".writer-container[data-v-00252826]{background-color:#f9f9f9}.update-img[data-v-00252826]{position:absolute;bottom:0;left:50%;transform:translate(-50%);background:hsla(0,0%,100%,.4);border:0;outline:none;cursor:pointer;padding:5px 10px;text-align:center}.update-img i[data-v-00252826]{vertical-align:middle;font-size:18px}", ""]);
// Exports
module.exports = exports;
